import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import {
  ENTITY_TYPE,
  ModalTitleVariant,
  PARENT_ENTITY_TYPE,
  LazyReportContentModal,
  ReportingContextProvider,
} from '@fiverr-private/content_reporting';
import { ReportPopover } from './ReportPopover';

interface WorkSampleReportCtaProps {
  filerrAttachmentId: string;
  title: ModalTitleVariant;
  orderId?: string;
  deliveryId?: string;
}

export const WorkSampleReportCta: React.FC<WorkSampleReportCtaProps> = ({
  deliveryId,
  filerrAttachmentId,
  orderId,
  title,
}) => {
  const {
    currentUser,
    general: { gigId, sellerId },
  } = useGigPageContext();

  if (currentUser?.status === 'restricted') {
    return null;
  }

  return (
    <Stack onClick={(e: React.MouseEvent) => e.stopPropagation()}>
      <ReportingContextProvider
        entityId={filerrAttachmentId}
        entityType={ENTITY_TYPE.ATTACHMENT}
        parentEntityType={PARENT_ENTITY_TYPE.GIG}
        parentEntityId={`${gigId}`}
        sellerId={`${sellerId}`}
        orderId={orderId}
        deliveryId={deliveryId}
        title={title}
        fetchOnMount={false}
      >
        <ReportPopover />
        <LazyReportContentModal />
      </ReportingContextProvider>
    </Stack>
  );
};
